import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Reports } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	reportData: [],
};

const setReportsData: ReduxReducer<State, State> = (state, action) => {
	state.reportData = action.payload.reportData;
};

const reportExecutorOrdersReportData = createSlice({
	name: Reports.ConstantReportSlice.EXECUTOR_ORDERS_REPORT,
	initialState,
	reducers: {
		setReportsData,
	},
});

export const reportExecutorOrdersReportDataAction =
	reportExecutorOrdersReportData.actions;
export const reportExecutorOrdersReportDataReducer =
	reportExecutorOrdersReportData.reducer;
export type reportExecutorOrdersReportDataState = State;

export default reportExecutorOrdersReportData;
